import { render, staticRenderFns } from "./SingleGlobalNote.vue?vue&type=template&id=8d6e161c&"
import script from "./SingleGlobalNote.vue?vue&type=script&lang=js&"
export * from "./SingleGlobalNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports